export default __webpack_public_path__ + "static/media/lining23.723e0959.jpeg";